import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { GeneratePasswordDto } from '../../dto/GeneratePasswordDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiGetGeneratePasssword = async (dto: GeneratePasswordDto) => {
  const params: IApiParams = {
    url: `/service/apiGetGeneratePasssword.php`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
